import { useGraphMetaInfo } from '@common/selectors';
import { getProviderType } from 'frontend/core/src/schema/util';

import { SqlGraph, SQLMetaInfo } from '../types';
import { useProviderTypeOverride } from './context';

export const useProviderTypes = () => {
  const providerTypeOverride = useProviderTypeOverride();
  const providerType = useGraphMetaInfo<SqlGraph, SQLMetaInfo['providerType']>(
    (metaInfo) => metaInfo.providerType || ''
  );
  return getProviderType(providerTypeOverride ?? providerType);
};
